import React, { Component } from 'react';
import Fx from './functions/functions';
import CountryList from './functions/CountryList';
import './css/AddressViewer.css';

class AddressViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: -1,
      title: '',
      forename: '',
      surname: '',
      company: '',
      line_1: '',
      line_2: '',
      line_3: '',
      city: '',
      county: '',
      country_code: 'GB',
      postcode: '',
      email: '',
      phone_number: ''
    }
  }
  update = (field,evt) => {
     var state = {};
     state[field] = evt.target.value;
     if(field == 'postcode'){
      state[field] = state[field].toUpperCase(); 
     }     
     else if(field == 'email'){
      state[field] = state[field].toLowerCase(); 
     }     
     this.setState(state);
	}
  render() {
    var address;
    var className = '';
    if(typeof this.props.onClick !== 'function' && !Fx.validateAddress(this.props.address)){
      address =  '';
      className = ' none';
    }
    else if(this.props.matched){
      address =  (<div>  <div className="addTitle">{this.props.title}</div>
      <div >Same as {this.props.matched}</div></div>);
      if(typeof this.props.onClick === 'function'){
        className = ' address_button';
      }
      else {
        className = ' sign';
      }
    }
    else if(typeof this.props.onClick === 'function' && !Fx.validateAddress(this.props.address)){
      var indef;
      if(-1 == 'aeiou'.indexOf(this.props.title.toLowerCase().substr(0,1))){
        indef = 'a';
      }
      else {
        indef = 'an';
      }
      address =  <div >Add {indef} {this.props.title}</div>;
      className = ' address_button';
    }
    else if(!Fx.validateAddress(this.props.address)){
      address =  <div >Collect from warehouse</div>;
      className = ' sign';
    }
    else{
      var country;
      CountryList.countries.some((nat, i)=>{
        if(this.props.address.country_code == nat.country_code){
           country = nat.country;
           return true;
        }
      })
      address =  (<div>
        <div className="addTitle">{this.props.title}</div>
        <div className="address">
          <div>{this.props.address.title} {this.props.address.forename} {this.props.address.surname}</div>
          <div>{this.props.address.company}</div>
          <div>{this.props.address.line_1}</div>
          <div>{this.props.address.line_2}</div>
          <div>{this.props.address.line_3}</div>
          <div>{this.props.address.city}</div>
          <div>{this.props.address.county}</div>
          <div>{country}</div>
          <div>{this.props.address.postcode}</div>
          <div><a href={'mailto:' + this.props.address.forename + ' ' + this.props.address.surname +'<' + this.props.address.email + '>'}>{this.props.address.email}</a></div>
          <div>{Fx.phoneFormat(this.props.address.phone_number)}</div>
        </div>
      </div>);
    }
    
    return (<div className={"AddressViewer" + className} onClick={this.props.onClick}>
        {address}
    </div>);
  }
}

export default AddressViewer;



// WEBPACK FOOTER //
// ./src/AddressViewer.js